export default {
    HANDLERS_NS: 'handlers',
    INTERSECTIONS: 'intersections',
    VIEWPORT_STATE: 'state',
    VIEWPORT_STATE_REQUESTS: 'stateRequests'    
}
